import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';
import styled, { css } from 'styled-components';

import { BRAND_COLORS } from 'brand-guidelines/colors';
import { TYPOGRAPHY } from 'brand-guidelines/typography';
import { Div, H2 } from 'common/styles/oc-styled-components';

export const DatesList = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  align-items: center;
  justify-items: center;

  width: 100%;
  column-gap: 2px;
  row-gap: 6px;

  background: ${BRAND_COLORS.dirtyWhite};
  padding: 10px;
  border-radius: 8px;
`;

export const SlotsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Column = styled(Div)`
  display: block;
  flex: 1;
`;

export const MonthRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
`;

export const Month = styled(H2)`
  color: ${BRAND_COLORS.black};
  ${TYPOGRAPHY.CIRCULAR.bold};
  line-height: 30px;
  margin: 0;
`;

export const NavigationButton = styled.button`
  display: flex;
  border: none;
  box-shadow: none;
  align-items: center;
  padding: 0;
  font-size: 20px;
  width: 20px;
  height: 20px;
  background: 0;
  cursor: pointer;

  &:disabled {
    cursor: default;
  }
`;

const iconAttributes = {
  size: 20,
};

const iconColor = ({ disabled }) =>
  disabled ? BRAND_COLORS.lightGray : BRAND_COLORS.black;

export const ChevronLeft = styled(IconChevronLeft).attrs(iconAttributes)`
  color: ${iconColor};
`;

export const ChevronRight = styled(IconChevronRight).attrs(iconAttributes)`
  color: ${iconColor};
`;

export const Slot = styled.button.attrs({
  type: 'button',
})`
  border-radius: 100px;

  width: 34px;
  height: 34px;
  text-align: center;

  ${TYPOGRAPHY.OPEN_SANS.bold};
  font-size: 14px;
  line-height: normal;
  color: ${BRAND_COLORS.lightGreen};

  border-style: solid;
  border-width: 1px;
  border-color: ${BRAND_COLORS.lightGreen};

  background-color: ${BRAND_COLORS.white};

  transition-property: border-color, background-color, color;
  transition-duration: 0.2s;
  transition-timing-function: ease-in-out;

  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.05) ;

  cursor: pointer;

  &:hover {
    color: ${BRAND_COLORS.white};
    border-color: ${BRAND_COLORS.lightGreen};
    background-color: ${BRAND_COLORS.lightGreen};
  }

  ${(props) =>
    props.disabled
    && css`
      color: ${BRAND_COLORS.lightGray};
      border-color: transparent;
      background-color: transparent;
      box-shadow: none;
      cursor: default;

      &:hover {
        border-color: transparent;
        background-color: transparent;
        color: ${BRAND_COLORS.lightGray};
      }
    `}

  ${(props) =>
    props.$isToday
    && css`
      text-decoration: underline;
    `}

  ${(props) =>
    props.$isSelected
    && css`
      color: ${BRAND_COLORS.white};
      border-color: ${BRAND_COLORS.lightGreen};
      background-color: ${BRAND_COLORS.lightGreen};
      cursor: default;
    `}
`;

export const Weekday = styled.p`
  color: ${BRAND_COLORS.darkGray};
  text-align: center;
  ${TYPOGRAPHY.OPEN_SANS.bold};
  font-size: 12px;
  font-style: normal;
  line-height: 20px;
`;
